var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b3d02d3c83eaf7e237de0209a4d7076bfe1b5125"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["webapp-frontend@mizar"]={id:"b3d02d3c83eaf7e237de0209a4d7076bfe1b5125"};
      